import React, { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authApi } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }

    const sessionId = match[1];

    (async () => {
      try {
        const res = await authApi.session(sessionId);
        setUser(res.data);
        window.history.replaceState(null, '', '/');
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Auth failed:', err);
        // 403 con `reason=not_invited` (security 2026-05-29): l'email Google
        // non è in `users` → reindirizza al login con un flag che innesca
        // un avviso amichevole "Accesso non autorizzato".
        const status = err?.response?.status;
        const detail = err?.response?.data?.detail || '';
        if (status === 403) {
          window.history.replaceState(null, '', '/login');
          navigate('/login', { replace: true, state: { unauthorized: detail || true } });
        } else {
          navigate('/login', { replace: true });
        }
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-black border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-sm text-slate-600">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
